import { GoPlus } from "react-icons/go";
import { Button } from "../../../../components/forms";
import { nodept } from "../../../../constant/import";
import { ListPicker } from "../../../../components/generic/ListPicker";
import { usePickerhook } from "../../../../hooks/usePickerhook";
import { useEffect, useState } from "react";
import Switch from "react-switch";
import MultiSelect from "../../../../components/generic/MultiSelect";
import useCalendarHook from "../../../../hooks/useCalendarHook";
import { countries } from "../../../../constant/data";
import { useStateSetter } from "../../../../hooks/statehooks/UseStateSettersHook";

export default ({ setshowadddept, leaves, refresh }: any) => {
  const EmptyList = () => (
    <div className=" mx-6 p-5 scale-[.75]   text-textbg flex flex-col justify-center rounded-xl items-center border border-gray-300 ">
      <img src={nodept} />
      <p className="font-bold">No Leave Type</p>
      <small>No leave type has been added</small>

      <Button
        width={200}
        disabled={false}
        text={
          <>
            <GoPlus size={15} className=" mx-1 inline" /> Add Type
          </>
        }
        onBtnClick={() => {
          setshowadddept(true);
        }}
      />
    </div>
  );

  const weekdays = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];
  const [enablecountryconf, setenablecountryconf] = useState(false);
  const { weekends, DeleteWeeekend, AddWeekend } = useCalendarHook();
  const weekendpickedhook = usePickerhook();
  const { setLoading } = useStateSetter();

  const WeekenddaysChange = async (selected: any) => {
    if (selected) {
    var tobedeleted = weekdays.filter((fsf: string) => !selected.includes(fsf) );
      setLoading(true);
      console.log(tobedeleted)

//Delete Unseleted Days from weekends

   tobedeleted.map(async (item) => {
        weekends.map(async (ll: any) => {
          if (ll.days == item) {
            try{
              await DeleteWeeekend(ll.id);

            }
            catch(e:unknown){

            }
          }
        });
      })
 
//Add selected days as weeekends
      selected.map(async (it:string)=>{
        try{

          await AddWeekend(it)
        }
catch(e:unknown){


}

      },[])
      setLoading(false);
    }
  };
  useEffect(() => {
    console.log(weekendpickedhook.pickedRole);
  }, [weekendpickedhook.pickedRole]);
  return (
    <div className=" ">
      <div className="flex justify-between p-2 border items-center border-1 border-gray-200 rounded ">
        <p className="text-textbg font-medium text-sm mb-2 text-[16px]  bg-white">
          Weekend
        </p>

        <MultiSelect
          hook={weekendpickedhook}
          notitle
          onchange={WeekenddaysChange}
          defaultvalue={weekends.map((kl: any) => {
            return kl.days;
          })}
          title="Weekdays"
          list={weekdays}
        />
      </div>

      <div className="flex justify-between items-center mt-4 ">
        <div>
          <p className="font-semibold text-lg ">Region-Specific</p>
          <p className=" font-light text-xs ">
            Options to apply region-specific configurations for different
            locations
          </p>
        </div>

        <Switch
          checkedIcon={false}
          uncheckedIcon={false}
          offColor="#EAECF5"
          onColor="#CB0E5F"
          className="m-4"
          onChange={async () => {
            setenablecountryconf((prev) => !prev);
          }}
          checked={enablecountryconf}
        />
      </div>

      {enablecountryconf && (
        <div className="flex justify-between items-center ">
          <p className=" font-light  ">Country</p>
          <ListPicker
            hook={weekendpickedhook}
            notitle
            title="Country"
            list={countries}
          />
        </div>
      )}
      <div></div>
    </div>
  );
};
